import React from "react";
import MenuItem from "@mui/material/MenuItem";
import { Typography } from "@mui/material";
import Menu from "./Menu";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import SearchIcon from "@mui/icons-material/Search";
import Field from "../Field/Fi";
import CheckIcon from "@mui/icons-material/Check";
const style = {
  margin: "4px 0px",
  marginBottom: "-8px",
  "&:hover": {
    color: "#255CCE",
    backgroundColor: "#fff",
  },
};

const language = [
  "English",
  "French",
  "Arabic",
  "Mandarin",
  "Italian",
  "Spanish",
  "German",
  "Russian",
  "Farsi",
  "Urdu",
  "Hindi",
].sort();

export default function Language() {
  const [currentLanguage, setCurrentLanguage] = React.useState("English");
  const [wordEntered, setWordEntered] = React.useState("");
  const [filteredData, setFilteredData] = React.useState(language);

  const handleChange = (curr) => () => {
    setCurrentLanguage(curr);
  };

  const handleFilter = (event) => {
    const searchWord = event.target.value;
    setWordEntered(searchWord);
    const newFilter = language.filter((value) => {
      return value.toLowerCase().includes(searchWord.toLowerCase());
    });
    if (searchWord === "") {
      setFilteredData([...language]);
    } else {
      setFilteredData(newFilter);
    }
  };

  return (
    <Menu
      text={currentLanguage}
      textVariant="subtitle2"
      buttonStyle={{ width: "68px", height: "20px", padding: "0px" }}
      textStyle={{ color: "text.primary" }}
      buttonVariant="text"
      icons={[<ArrowDropDownIcon />]}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      paperStyle={{
        width: "360px",
        maxHeight: "440px",
        borderRadius: "4px",
        marginTop: "10px",
        position: "relative",
      }}
    >
      <MenuItem
        sx={{
          position: "fixed",
          width: "326px",
          padding: "16px 0px 0px 0px !important",
          margin: "-8px 16px 0px",
          zIndex: "1",
          backgroundColor: "#fff !important",
          "&:hover": {
            backgroundColor: "#fff",
          },
        }}
        disableRipple
      >
        <Field
          label="Search Language"
          borderColor="#DFDFDF"
          size="small"
          endIcon={<SearchIcon sx={{ color: "#808080" }} />}
          value={wordEntered}
          handleChange={handleFilter}
          transform="translate(7px,7px)"
          labelVariant="body2"
          labelFont="14px"
        ></Field>
      </MenuItem>
      <MenuItem
        sx={{
          marginTop: "46px",
          "&:hover": {
            backgroundColor: "#fff",
          },
        }}
        disableRipple
      >
        <Typography
          variant="caption"
          fontWeight="400"
          fontSize="12px"
          lineHeight="16px"
          color="#616161"
          sx={{ marginTop: "12px", paddingY: "0px", marginBottom: "-8px" }}
        >
          LANGUAGE
        </Typography>
      </MenuItem>
      {filteredData.map((currency) => {
        return (
          <MenuItem
            disableRipple
            sx={{
              ...style,
              color: currency.includes(currentLanguage) && "#4420A1",
            }}
            onClick={handleChange(currency)}
          >
            <Typography
              variant="body1"
              fontWeight="400"
              fontSize="16px"
              lineHeight="24px"
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
                fontWeight:
                  currency.includes(currentLanguage) && "700 !important",
              }}
            >
              {currency}
              {currency.includes(currentLanguage) && (
                <CheckIcon sx={{ fontSize: "16px", color: "#4420A1" }} />
              )}
            </Typography>
          </MenuItem>
        );
      })}
    </Menu>
  );
}
